var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 37H31C29.9 37 29 36.1 29 35V26H33V33H42V37Z",
    fill: "#5C4841"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 28H44C42.9 28 42 28.9 42 30V40C42 41.1 42.9 42 44 42H45V28ZM35 18C35 20 35 21.8 35 24C35 26.2 33.2 28 31 28C28.8 28 27 26.2 27 24C27 21.8 27 18 27 18H35Z",
    fill: "#8D6E63"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99999 19.2C4.99999 19.2 4.69999 23 8.59999 24.1C12.5 25.2 11.9 16.4 11.9 16.4L4.99999 19.2Z",
    fill: "#3F51B5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9 19.8L16 30.8L9.29999 17.3L33.8 6.30005L39.9 19.8Z",
    fill: "#EE8003"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1 11.1C42.8 14.8 42.2 18.6999 39.8 19.7999C37.4 20.8999 34.2 18.7 32.5 15C30.8 11.3 31.4 7.39995 33.8 6.29995C36.1 5.19995 39.4 7.39995 41.1 11.1Z",
    fill: "#EE8003"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8 22.2999C18.5 25.9999 18.1 29.7999 15.9 30.7999C13.7 31.7999 10.6 29.4999 9 25.7999C7.4 22.0999 7.7 18.2999 9.9 17.2999C12.1 16.2999 15.2 18.4999 16.8 22.2999Z",
    fill: "#7D4709"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9 23.2C13.8 20.8 12.1 19.3 11 19.7C9.89999 20.1 9.89999 22.5 11 24.9C12.1 27.3 13.8 28.8 14.9 28.4C16 27.9 16 25.6 14.9 23.2Z",
    fill: "#E8E8E8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7 24.7C13.3 24.7 13 24.5 12.8 24.1C12.5 23.4 12.2 23 12 22.8C11.6 22.8 11.3 22.6 11.1 22.2C10.9 21.7 11.1 21.1 11.6 20.9C12 20.7 12.7 20.6 13.5 21.6C13.9 22 14.3 22.6 14.6 23.3C14.8 23.8 14.6 24.4 14.1 24.6C14 24.7 13.8 24.7 13.7 24.7Z",
    fill: "#EAB06E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7 6.30003L5 19.2C5 19.2 10.1 17.6 17.1 22.8C23.3 20.1 41.2 11.6 41.2 11.6C41.1 11.5 41.1 11.3 41 11.2C39.4 7.40003 36.1 5.20003 33.7 6.30003Z",
    fill: "#8D6E63"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.4048877ed826b2b31571fbf1b86e0971.svg";
export { ForwardRef as ReactComponent };